import * as React from "react";
const SvgFiRrLamp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lamp_svg__a)">
      <path
        fill="#062147"
        d="m23.955 10.212-.778-6.095A4.73 4.73 0 0 0 18.5 0H5.489A4.724 4.724 0 0 0 .813 4.117l-.779 6.095A4.25 4.25 0 0 0 4.25 15h6.749v1c0 1.827-1.536 1.993-2 2-1.654 0-3 1.346-3 3s1.346 3 3 3h6c1.654 0 3-1.346 3-3a3.004 3.004 0 0 0-2.895-2.998c-.364-.078-2.105-.527-2.105-2.002v-1h6.739a4.248 4.248 0 0 0 4.215-4.788zM15 20a1.001 1.001 0 0 1 0 2H9a1.001 1.001 0 0 1 0-2c.983 0 2.26-.398 3.103-1.378A4.95 4.95 0 0 0 15 20m6.428-7.763A2.25 2.25 0 0 1 19.74 13H4.251a2.247 2.247 0 0 1-2.232-2.535l.779-6.095A2.72 2.72 0 0 1 5.489 2H18.5a2.72 2.72 0 0 1 2.692 2.37l.778 6.095a2.25 2.25 0 0 1-.542 1.772"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lamp_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLamp;
